// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3AEt8","col":"styles_col__1O02G","fulfillmentStatus":"styles_fulfillmentStatus__lWy6A","emailCol":"styles_emailCol__1AFPx"};